import { environment } from '../environments/environment';

export const apiUrl = environment.apiUrl;
export const API_ENDPOINT = environment.apiEndpoint;
export const SERVER_URL = environment.serverUrl;
export const SERVER_HOST = environment.serverHost;
export const CALENDAR_HOST = environment.calendarHost;
export const USE_LOCAL_WEBSOCKET = environment.useLocalWebSocket;
export const BASIS_THEORY_ENV = environment.basisTheoryEnvironment;
export const VERSION = environment.version;
export const ENVIRONMENT = environment.environment;
export const ASSISTANT_URL = environment.assistantUrl;


// WEBPACK FOOTER //
// ./src/app/app.config.ts